import type { ApiGenericResponse } from '../../typings'

export interface SettingsResponse {
  countries: {
    id: string
    title: {
      fa: string
      en?: string
    }
    flagUrl?: string
    iso: string
    callingCode: number
  }[]

  currencies: {
    id: string
    titleFa: string
    titleEn: string
  }[]
}

export function getSettingsAction<T = ApiGenericResponse<SettingsResponse>>(): Promise<T> {
  const { api } = useApi()
  return api.get<T>('/v1/settings')
}
